import { SystemLogSeverities } from 'generated/graphql-types';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { SystemLogSeverityOption } from '../system-logs-severity-option.interface';
import { systemLogSeverityOptionActions } from './system-logs-severity-select-option.actions';

export const systemLogSeverityOptionFeatureKey = 'systemLogSeverityOptions';

export type SystemLogSeverityOptionState = EagerSelectState<SystemLogSeverityOption>;

const adapter = createEagerSelectAdapter<SystemLogSeverityOptionState, SystemLogSeverityOption>({
   featureKey: systemLogSeverityOptionFeatureKey,
   selectId: (severity: SystemLogSeverityOption) => {
      return severity.systemLogSeverityId ?? '';
   },
});

export const systemLogSeverityOptionSelectors = adapter.getSelectors(filterSeverityTypeNameOption);

const initialState = adapter.getInitialState();

export const systemLogSeverityOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   systemLogSeverityOptionActions.search,
   systemLogSeverityOptionActions.searchReset,
   systemLogSeverityOptionActions.loadFromApi,
   systemLogSeverityOptionActions.loadFromApiSuccess,
   systemLogSeverityOptionActions.loadFromApiFailure
);

export function filterSeverityTypeNameOption<T extends SystemLogSeverityOption>(
   types: T[],
   searchText: string | null | undefined
): T[] {
   const filteredOptions: T[] = Object.values(SystemLogSeverities)
      .filter((name) => {
         if (searchText) {
            return name.toLowerCase().includes(searchText.toLowerCase());
         } else {
            return true;
         }
      })
      .map((name) => {
         return { name } as unknown as T;
      });

   return filteredOptions;
}
